import { defaultPaymentPlans, defaultReceptionistPaymentPlans } from './payment-plans.environment';
import { PhoneSettingProvider } from '../models/enums/phone-settings-provider';

const host = `https://aiconversationalagent.onrender.com`;
export const googlePlaceApiKey = "AIzaSyAFnNFcKszpqCKhFVErM7AHAVDPK6strPo";
export const environment = {
  production: false,
  showDocumentationLink: true,
  onboarding: {
    guidedTourEnabled: true,
    restartWorkflowEnabled: true,
  },
  bookingUrl: 'https://calendly.com/pulsyaiservice/30min?month=2026-02',
  appName: "Pulsy",
  shadowAccountEmailDomain: 'internal.pulsy.ai',
  paymentPlans: defaultPaymentPlans,
  receptionistPaymentPlans: defaultReceptionistPaymentPlans,
  facebookPixel: {
    enabled: false,
    pixelId: '1011948501081760',
  },
  googlePixel: {
    enabled: false,
    tagId: 'AW-18335310592',
    purchaseConversionId: 'AW-18335310592/kzS4CNuM7dMcEIDG-qZE',
    signupConversionId: 'AW-18335310592/uj_YCOiA9-EcEIDG-qZE',
    defaultCurrency: 'CAD',
    defaultPurchaseValue: 1.0,
    defaultSignupCurrency: 'CAD',
    defaultSignupValue: 1.0,
  },
  openAiAds: {
    enabled: true,
    pixelId: 'VEghmSVnXPufrztevyUJaF',
    debug: true,
    consentRequired: false,
  },
  customDeployement: {
    enabled: true,
    smsEnabled: true,
    enablePlatformConfiguration: true,
    enableManagedUserVisiblePlanSelection: true,
    faveicon: "",
    defaultLogo: "",
    enablePhoneNumberBuying: true,
    enableAccountCreation: true,
    enableComplianceTab: true,
    enableHipaaRecording: true,
    enableSipRegistrationTrunk: true,
    enableSipRegistrarTrunk: true,
    enableSipSrvRecords: false,
    enableInterfaceTemplates: true,
    enableSubscriptionEmailToggle: true,
    importablePhoneProviders: [
      PhoneSettingProvider.TWILIO,
      PhoneSettingProvider.TELNYX,
      PhoneSettingProvider.SIP_TRUNK
    ],
    enabledIntegrations: {
      ghl: true,
      meta: true,
      googlePixel: false,
      googleLogin: true
    }
  },
  fronEndUrl: "https://pulsy-frontend-app-dev.onrender.com",
  frontEndIp: "216.24.57.1",
  sipForwardingHost: "pulsy.sip.jambonz.cloud",
  sipGatewayAddress: "54.236.168.131:5060",
  livekit: {
    url: 'wss://pulsy-xnq7bn9w.livekit.cloud',
  },
  baseUrl: `${host}`,
  authUrl: `${host}/auth`,
  analyticsUrl: `${host}/analytics`,
  livekitUrl: `${host}/livekit`,
  messengerIntegrationUrl: `${host}/messengerIntegration`,
  customApiCallUrl: `${host}/customApiCall`,
  dtmfToolUrl: `${host}/dtmf`,
  keypadInputToolUrl: `${host}/keypadInputTool`,
  hangUpToolUrl: `${host}/hangUpTool`,
  webhookUrl: `${host}/webhook`,
  agencyPermissionsUrl: `${host}/agencyPermissions`,
  subAccountPermissionsUrl: `${host}/subAccountPermissions`,
  telephonyUrl: `${host}/phone`,
  registrationUrl: `${host}/registration`,
  autoCallBackSettingsUrl: `${host}/autoCallBackSettings`,
  callBackSettingsUrl: `${host}/callBackSettings`,
  whiteLabel: `${host}/whitelabel`,
  validationUrl: `${host}/validation`,
  userUrl: `${host}/user`,
  telegramUrl: `${host}/telegram`,
  voiceUrl: `${host}/voice`,
  llmChoiceUrl: `${host}/llmChoice`,
  fallbackLlmChoiceUrl: `${host}/fallbackLlmChoice`,
  fallbackVoiceChoiceUrl: `${host}/fallbackVoiceChoice`,
  voicemailDetectionStrategyUrl: `${host}/voicemailDetectionStrategy`,
  knowledgeUrl: `${host}/knowledge`,
  aiAgentUrl: `${host}/business`,
  agentTemplateUrl: `${host}/agentTemplate`,
  serviceUrl: `${host}/service`,
  smsSettingsUrl: `${host}/smsSettings`,
  callsUrl: `${host}/calls`,
  customDomainUrl: `${host}/customDomain`,
  customColorUrl: `${host}/customColor`,
  formUrl: `${host}/form`,
  transferUrl: `${host}/transfer`,
  sipUrl: `${host}/sip`,
  textMessageUrl: `${host}/textMessage`,
  textConversationUrl: `${host}/textConversation`,
  conversationStepUrl: `${host}/conversationStep`,
  staleSmsSettingsUrl: `${host}/staleSmsConversationSettings`,
  zapUrl: `${host}/zap`,
  makeUrl: `${host}/make`,
  callLogUrl: `${host}/callLog`,
  paymentUrl: `${host}/paymentPlan`,
  rebillingUrl: `${host}/rebilling`,
  billingOverviewUrl: `${host}/billingOverview`,
  websocketUrl: `${host}/message`,
  outboundCampaignUrl: `${host}/outbound`,
  smsCampaignUrl: `${host}/smsCampaign`,
  notificationIntegrationUrl: `${host}/notificationIntegration`,
  phoneSettingsUrl: `${host}/phoneSettings`,
  smtpSettingsUrl: `${host}/smtpSettings`,
  googleSheetsIntegrationUrl: `${host}/googleSheet`,
  privacySettingsUrl: `${host}/privacySettings`,
  dataRetentionSettingUrl: `${host}/dataRetentionSetting`,
  piiSettingUrl: `${host}/piiSetting`
};
